import { z } from "zod";

export const contactFormSchema = z.object({
  name: z.string().min(2, {
    message: "Namnet måste vara minst 2 tecken.",
  }),
  email: z.string().email({
    message: "Ogiltig e-postadress.",
  }),
  message: z.string().min(2, {
    message: "Meddelandet måste vara minst 2 tecken.",
  }),
  phone: z.string().min(2, {
    message: "Telefonnumret måste vara minst 2 tecken.",
  }),
  website: z.string().length(0), // Honeypot field must be empty
});
